import { Component, OnInit, Input, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { CitizenService } from '../../../module/citizen/citizen.service';
import { AadharOtpResponse,RationcardResponse } from '../../Models/AadharVerifyModel';
import { Router } from '@angular/router';
import { ToastService } from '../../services/toast.service';
import { DevelopmentService } from '../../services/development.service';
import { LanguageService } from '../../services/language.service';
import { LoginService } from '../../services/login.service';
import { TextToSpeechService } from '../../services/text-to-speech.service';
import { EncryptionService } from '../../services/encryption.service';
import { RDService } from '../../services/rd.service';
import { HomeService } from '../../../module/home/home.service';
import { SMSModel } from '../../Models/CommonModel';

declare const bootstrap: any;
@Component({
  selector: 'register-modal',
  templateUrl: './register-modal.component.html',
  styleUrl: './register-modal.component.scss'
})
export class RegisterModalComponent implements OnInit {
  // Set to true to show the maintenance message instead of the registration form.
  isMaintenanceMode: boolean = false;
  maintenanceMessage: string = 'New registration is temporarily unavailable due to scheduled maintenance';

  registerModal: any;
  govEmployeeModal: any;
  pendingOtpResponse: any = null;
  registrationForm!: FormGroup;
  registrationStep: number = 1;
  aadhar: FormGroup;
  @Input() reKyc: string;
  @Input() eKycProcess: any;
  activeLanguage: any;

  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;
  sessionid: any;

  isRationMode = false;
  rationSwitchUsed = false;
  Memberid: any='';
  RationCard:any='';
  Aadharrefkey:any='';
  RationcardAadharrefkey:any='';

  private IpAddess: string;
  aadharNumber: string;
  rationCardMemberId: string;
  rationRefNo: string;
  constructor(private fb: FormBuilder, private citizenService: CitizenService, private router: Router, private toasterService: ToastService, private DS: DevelopmentService,
    public langService: LanguageService, protected encryptionService: EncryptionService,
    private loginService: LoginService,
    protected textToSpeechService: TextToSpeechService,
     public langTranslation: LanguageService,
    protected rdservice: RDService,
    private homeService: HomeService,) { }
  ngOnInit(): void {

    document.addEventListener('keydown', this.handleKeyboardEvent);
    this.registerModal = new bootstrap.Modal(document.getElementById('registerModal'), { backdrop: 'static', focus: true, keyboard: false });
    this.registerModal._element.addEventListener(
      'hidden.bs.modal',
      () => {
        this.resetOTPFields();
        this.clearOtpLockTimer();
        // Clear stale "already exists" / ration-linking state so it doesn't
        // leak into the next time this modal is opened (e.g. after the
        // modal auto-closes on the 3rd wrong OTP attempt).
        this.usermasterdata = null;
        this.isrationcard = false;
        this.RationcardAadharrefkey = '';
        // Also clear the entered Aadhaar/Ration card number so it doesn't
        // stay pre-filled the next time "Create your Maha ID" is opened.
        this.resetAadharForm();
      }
    );
    this.registerModal._element.addEventListener('hide.bs.modal', () => {
    });
    this.registerModal._element.addEventListener('show.bs.modal', () => {
      this.registrationForm.reset();
      // this.aadhar.reset();
      this.registrationStep = 1;
    });
    this.registerModal._element.addEventListener('shown.bs.modal', () => {
      // always open with the consent text at the top
      this.resetConsentScroll();
    });
    this.govEmployeeModal = new bootstrap.Modal(document.getElementById('govEmployeeModal'), { backdrop: 'static', focus: true, keyboard: false });
    this.registrationForm = this.fb.group({
      aadharNumber: ['', Validators.required],
      otp: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
    this.aadhar = this.fb.group({
      selectedIdType: ['aadhar'],
      aadharNumber: ['', [Validators.required, Validators.pattern('(^[2-9][0-9]{11}$)|(^[0-9]{16}$)')]],
      consent: [{ value: false, disabled: true }, [Validators.requiredTrue]],
      mahaId: ['', [Validators.minLength(11), Validators.maxLength(11), Validators.pattern('^[0-9]{11}$')]],
      rationCardMemberId:['', [Validators.required, Validators.pattern('(^[2-9][0-9]{11}$)|(^[0-9]{14}$)')]],
    });

    this.aadhar.patchValue({ selectedIdType: 'aadhar' });
    if (this.eKycProcess) {
      this.aadhar.patchValue({ aadharNumber: this.eKycProcess.aadharno });
    }
    this.aadhar.get('mahaId')?.clearValidators();
    this.aadhar.get('mahaId')?.setValue('');
    this.aadhar.get('rationCardMemberId')?.clearValidators();
    this.aadhar.get('rationCardMemberId')?.setValue('');
    this.aadhar.get('aadharNumber')?.updateValueAndValidity();
    this.aadhar.get('mahaId')?.updateValueAndValidity();
    this.aadhar.get('rationCardMemberId')?.updateValueAndValidity();

    // Watch selectedIdType and apply validators
    this.aadhar.get('selectedIdType')?.valueChanges.subscribe(type => {

      if (type === 'aadhar') {
        this.aadhar.get('aadharNumber')?.setValidators([
          Validators.required,
          Validators.pattern(/(^[2-9][0-9]{11}$)|(^[0-9]{16}$)/)
        ]);
        this.aadhar.get('mahaId')?.clearValidators();
        this.aadhar.get('mahaId')?.setValue('');
        this.aadhar.get('rationCardMemberId')?.clearValidators();
        this.aadhar.get('rationCardMemberId')?.setValue('');
      }
      else if (type === 'ration') {
        this.aadhar.get('rationCardMemberId')?.setValidators([
          Validators.required,
          Validators.pattern(/(^[2-9][0-9]{11}$)|(^[0-9]{14}$)/)
        ]);

        this.aadhar.get('aadharNumber')?.clearValidators();
        this.aadhar.get('aadharNumber')?.setValue('');
        this.aadhar.get('mahaId')?.clearValidators();
        this.aadhar.get('mahaId')?.setValue('');
      }
      else if (type === 'mahaid') {
        this.aadhar.get('mahaId')?.setValidators([
          Validators.required,
          Validators.pattern(/^[0-9]{11}$/)
        ]);
        this.aadhar.get('aadharNumber')?.clearValidators();
        this.aadhar.get('aadharNumber')?.setValue('');
        this.aadhar.get('rationCardMemberId')?.clearValidators();
        this.aadhar.get('rationCardMemberId')?.setValue('');
      }

      this.aadhar.get('aadharNumber')?.updateValueAndValidity();
      this.aadhar.get('mahaId')?.updateValueAndValidity();
      this.aadhar.get('rationCardMemberId')?.updateValueAndValidity();
    });
    this.RationcardAadharrefkey='';
    this.isrationcard=false;
  }


  setRationMode() {
   if (this.rationSwitchUsed) return;

    this.rationSwitchUsed = true;

    this.selectedIdType = 'ration';
    this.aadhar.get('selectedIdType')?.setValue('ration');

    // reset fields
    this.aadhar.get('aadharNumber')?.reset();
    this.realAadhaarNumber = '';
    this.showAadhaar = false;

    // reset consent state
    this.isScrolledToBottom = false;
    this.aadhar.get('consent')?.disable();
    this.aadhar.get('consent')?.reset();
  }

  setAadhaarMode() {
    this.selectedIdType = 'aadhar';
    this.aadhar.get('selectedIdType')?.setValue('aadhar');

    this.aadhar.get('consent')?.disable();
    this.isScrolledToBottom = false;

    this.aadhar.get('consent')?.reset();
  }




  @ViewChild('consentBox') consentBox!: ElementRef;
  @ViewChild('aadhaarInput') aadhaarInput!: ElementRef;
  @ViewChild('rationInput') rationInput!: ElementRef;
  isScrolledToBottom = false;
  isChecked = false;

  isConsentUnlocked = false;
  selectedIdType: 'aadhar' | 'ration' = 'aadhar';

  setIdType(type: 'aadhar' | 'ration') {
  this.selectedIdType = type;
  this.aadhar.patchValue({ selectedIdType: type });
  // reset fields when switching
  this.aadhar.get('consent')?.reset();
  this.aadhar.get('aadharNumber')?.reset();
  this.aadhar.get('rationCardMemberId')?.reset();

  // new consent text → read it again from the top
  this.aadhar.get('consent')?.disable();
  this.isConsentUnlocked = false;
  this.isScrolledToBottom = false;
  setTimeout(() => this.resetConsentScroll(), 0);
}


  unlockConsent() {
  this.isConsentUnlocked = true;

  // enable checkbox
  this.aadhar.get('consent')?.enable();

  // smoothly scroll the consent text down to the end (2 seconds)
  setTimeout(() => this.animateConsentScroll(2000), 0);
}

  private consentScrollFrame: number | null = null;

  /** Scroll the consent box to the bottom over `duration` ms (ease-in-out) */
  private animateConsentScroll(duration: number) {
    const element = this.consentBox?.nativeElement as HTMLElement | undefined;
    if (!element) return;

    this.stopConsentScrollAnimation();

    const start = element.scrollTop;
    const distance = element.scrollHeight - element.clientHeight - start;
    if (distance <= 0) return;

    const startTime = performance.now();
    const easeInOut = (t: number) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

    const step = (now: number) => {
      const progress = Math.min((now - startTime) / duration, 1);
      element.scrollTop = start + distance * easeInOut(progress);

      this.consentScrollFrame = progress < 1 ? requestAnimationFrame(step) : null;
    };
    this.consentScrollFrame = requestAnimationFrame(step);
  }

  private stopConsentScrollAnimation() {
    if (this.consentScrollFrame !== null) {
      cancelAnimationFrame(this.consentScrollFrame);
      this.consentScrollFrame = null;
    }
  }

onScroll() {
  const element = this.consentBox.nativeElement;

  const atBottom =
    Math.ceil(element.scrollTop + element.clientHeight) >= element.scrollHeight;

  // Reached the end of the consent text → enable the checkbox and hide "Read More"
  if (atBottom && !this.isScrolledToBottom) {
    this.isScrolledToBottom = true;
    this.isConsentUnlocked = true;

    this.aadhar.get('consent')?.enable();
  }
}

  /** Put the consent text back at the top (instant, no animation) */
  private resetConsentScroll() {
    // a running Read More animation must not keep scrolling after a reset
    this.stopConsentScrollAnimation();

    const element = this.consentBox?.nativeElement as HTMLElement | undefined;
    if (element) {
      element.scrollTop = 0;
    }
  }


  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.handleKeyboardEvent);
    this.clearOtpLockTimer();
    this.stopConsentScrollAnimation();
    this.registerModal.dispose();
    this.govEmployeeModal?.dispose();
  }

  openGovEmployeeModal(): void {
    this.govEmployeeModal.show();
  }

  confirmGovEmployee(isGovEmployee: boolean): void {
    sessionStorage.setItem('isGovEmployee', isGovEmployee ? 'true' : 'false');
    this.govEmployeeModal.hide();
    const response = this.pendingOtpResponse;
    this.pendingOtpResponse = null;
    if(isGovEmployee==true)
    {
       this.router.navigate(['/consent-to-access-registered'], { state: { detail: response.aadhardetails, sessionId: this.sessionid,isGovEmployee: true } });

    }
     }

  resetOTPFields() {
    // Reset reactive form
    //this.otpForm.reset();
    if(this.otpForm!=undefined){
    this.otpForm.patchValue({
      otp: '',
    });
    }

    // Clear internal OTP array
    this.otpValues = [];

    // Clear UI input boxes
    if (this.otpInputs) {
      this.otpInputs.forEach((input) => {
        input.nativeElement.value = '';
      });
    }

    // Reset timer
    this.resetTimer();
  }

  openModal(): void {
    this.registerModal.show();
  }

  resetAadharForm(): void {
    this.aadhar.reset({
      selectedIdType: 'aadhar',
      aadharNumber: '',
      rationCardMemberId: ''
    });

    this.aadharNumber = '';
    this.rationCardMemberId = '';

    this.selectedIdType = 'aadhar';
    this.showAadhaar = false;
    this.showRation = false;

    this.realAadhaarNumber = '';

    this.aadhar.get('consent')?.reset();
    this.aadhar.get('consent')?.disable();
    this.isConsentUnlocked = false;
    this.isScrolledToBottom = false;

    if (this.aadhaarInput) {
      this.aadhaarInput.nativeElement.value = '';
    }
    // consent text back to the top
    this.resetConsentScroll();
    this.aadhar.patchValue({ selectedIdType: 'aadhar' });
  }

  /** Close (X) → reset the whole modal so the next open starts fresh */
  closeModal(): void {
    this.textToSpeechService.stopAudio();

    this.resetAadharForm();
    this.resetOTPFields();
    this.clearOtpLockTimer();

    this.registrationStep = 1;
    this.rationSwitchUsed = false;
    this.isRationMode = false;
    this.usermasterdata = null;
    this.isrationcard = false;
    this.RationcardAadharrefkey = '';
    this.otpWrongAttempts = 0;

    this.registerModal.hide();
  }
  aadharvaluatkey: any;
  usermasterdata: any;
  mahaId: any;
  isLoading: boolean = false;
  successMessage: string | null = null;
  errorMessage: string | null = null;
  otpForm: FormGroup;
  minutesDisplay = '02';
  secondsDisplay = '00';
  totalSeconds = 120;
  interval: any;
  isdisableResend: boolean = true;
  isrationcard:boolean=false;
  otpWrongAttempts = 0;
  otpVerifyLocked = false;
  otpLockSecondsRemaining = 0;
  private otpLockIntervalId: any;

  startOtpLockTimer(): void {
    this.clearOtpLockTimer();
    this.otpVerifyLocked = true;
    this.otpLockSecondsRemaining = 30;
    this.otpLockIntervalId = setInterval(() => {
      this.otpLockSecondsRemaining--;
      if (this.otpLockSecondsRemaining <= 0) {
        this.clearOtpLockTimer();
      }
    }, 1000);
  }

  clearOtpLockTimer(): void {
    clearInterval(this.otpLockIntervalId);
    this.otpLockIntervalId = null;
    this.otpVerifyLocked = false;
    this.otpLockSecondsRemaining = 0;
  }

  async sendOTP() {

    if (this.aadhar.valid) {
      try {
        if (this.aadhar.value.selectedIdType === 'aadhar') {
            let aadharnumber = this.encryptionService.encrypt(this.aadhar.value.aadharNumber);
            let userType='Citizen';

            if(this.isrationcard==true){
            //this.aadharvaluatkey = await this.getAadharVaultKey(this.encryptionService.encrypt(this.aadhar.value.aadharNumber));

                  this.citizenService.VerifyRationcardadhhar(aadharnumber).subscribe({
                    next: (response:RationcardResponse) => {
                      this.isLoading = false;

                              if (response.status == true) {

                                          if( response.refNo == this.RationcardAadharrefkey){
                                            this.isrationcard=false;
                                            this.RationcardAadharrefkey='';
                                                  this.citizenService.sendAadharMobileOTP(aadharnumber,userType).subscribe({
                                                    next: (response: AadharOtpResponse) => {
                                                      this.isLoading = false;
                                                      this.RationcardAadharrefkey='';
                                                      this.isrationcard=false;
                                                      if (response.userExists) {
                                                        this.usermasterdata = [1];
                                                        this.successMessage = null;
                                                        this.errorMessage = null;
                                                        return;
                                                      }

                                                      if (response.status == true) {
                                                        this.toasterService.show(`OTP sent successfully!`, {
                                                          class: 'success',
                                                          title: 'Success',
                                                        });
                                                        this.successMessage = null;
                                                        this.errorMessage = null;
                                                        // Send OTP logic here
                                                        // Upon successful OTP sent, move to next step
                                                        this.registrationStep = 2;
                                                        this.otpWrongAttempts = 0;
                                                        this.clearOtpLockTimer();
                                                        this.otpForm = this.fb.group({
                                                          otp: ['', [Validators.required, Validators.pattern('^[0-9]{6}$'), Validators.minLength(6), Validators.maxLength(6)]],
                                                          transactionNumber: [response.transactionNo, [Validators.required]],
                                                          aadhaarNumber: [aadharnumber, [Validators.required]],
                                                          selectedIdType: ['aadhar'],
                                                        });
                                                        clearInterval(this.interval);
                                                        this.resetTimer();
                                                        this.startTimer();
                                                      } else {
                                                        this.toasterService.show(`Failed to send OTP. Please try again.`, {
                                                          class: 'danger',
                                                          title: 'Failure',
                                                        });
                                                        this.successMessage = null;
                                                        this.errorMessage = null;
                                                        this.registrationStep = 1;
                                                      }
                                                    },
                                                    error: (error) => {
                                                      this.isLoading = false;
                                                      this.successMessage = null;
                                                      this.errorMessage = null;
                                                      this.toasterService.show(`Failed to send OTP. Please try again.`, {
                                                        class: 'danger',
                                                        title: 'Failure',
                                                      });
                                                    }
                                                  });
                                          }
                                          else{
                                            const errorMsg = 'The details in your Aadhaar record do not match the information linked to your Ration Card Member ID. Please check that you have entered the correct Member ID. If the mismatch persists, you may still complete your registration using your Aadhaar number. [Register using Aadhaar eKYC]';
                                            let translatedMsg = this.langService.getTranslationSync(errorMsg);
                                            this.toasterService.show(translatedMsg, {
                                            class: 'danger',
                                            title: 'Failure',
                                            });

                                          //  this.aadhar.reset();
                                            //this.isrationcard=false;
                                            //this.RationcardAadharrefkey='';
                                          }
                              } else {
                                this.toasterService.show(`Something went wrong.`, {
                                  class: 'danger',
                                  title: 'Failure',
                                });
                                this.successMessage = null;
                                this.errorMessage = null;
                                this.registrationStep = 1;
                              }
                    },
                    error: (error) => {
                      this.isLoading = false;
                      this.successMessage = null;
                      this.errorMessage = null;
                      this.toasterService.show(`Failed to send OTP. Please try again.`, {
                        class: 'danger',
                        title: 'Failure',
                      });
                    }
                  });



            }
            else
            {
              this.citizenService.sendAadharMobileOTP(aadharnumber,userType).subscribe({
                next: (response: AadharOtpResponse) => {
                  this.isLoading = false;
                  if (response.userExists) {
                    this.usermasterdata = [1];
                    this.successMessage = null;
                    this.errorMessage = null;
                    return;
                  }

                  if (response.status == true) {
                    this.toasterService.show(`OTP sent successfully!`, {
                      class: 'success',
                      title: 'Success',
                    });
                    this.successMessage = null;
                    this.errorMessage = null;
                    // Send OTP logic here
                    // Upon successful OTP sent, move to next step
                    this.registrationStep = 2;
                    this.otpWrongAttempts = 0;
                    this.clearOtpLockTimer();
                    this.otpForm = this.fb.group({
                      otp: ['', [Validators.required, Validators.pattern('^[0-9]{6}$'), Validators.minLength(6), Validators.maxLength(6)]],
                      transactionNumber: [response.transactionNo, [Validators.required]],
                      aadhaarNumber: [aadharnumber, [Validators.required]],
                      selectedIdType: ['aadhar'],
                    });
                    clearInterval(this.interval);
                    this.resetTimer();
                    this.startTimer();
                  } else {

                    this.toasterService.show(`Failed to send OTP. Please try again.`, {
                      class: 'danger',
                      title: 'Failure',
                    });
                    this.successMessage = null;
                    this.errorMessage = null;
                    this.registrationStep = 1;
                  }
                },
                error: (error) => {
                  this.isLoading = false;
                  this.successMessage = null;
                  this.errorMessage = null;
                  this.toasterService.show(`Failed to send OTP. Please try again.`, {
                    class: 'danger',
                    title: 'Failure',
                  });
                }
              });
            }


        }
        else if (this.aadhar.value.selectedIdType === 'ration') {
          var aadharnumber = this.encryptionService.encrypt(this.aadhar.value.rationCardMemberId);


          this.citizenService.sendVerifyMemberIdDetails(aadharnumber,sessionStorage.getItem('ipaddrss')).subscribe({
            next: (response: AadharOtpResponse) => {

              this.isLoading = false;
              if (response.userExists) {
                this.usermasterdata = [1];
                this.successMessage = null;
                this.errorMessage = null;
                return;
              }

              if (response.status == true) {
                let mobile = response.data[0].mobile;
                let lastFourDigits = mobile.slice(-4);

                const errorMsg = 'OTP sent to XXXXXXX successfully!';
                let translatedMsg = this.langService.getTranslationSync(errorMsg);

                translatedMsg = translatedMsg.replace('XXXXXXX', 'XXXXXXX' + lastFourDigits);

                this.toasterService.show(translatedMsg, {
                class: 'success',
                title: 'Success',
                });

                this.Memberid =this.aadhar.value.rationCardMemberId;
                this.RationCard =response.data[0].ration_card_number;
                this.Aadharrefkey =response.data[0].advrefkey;

                this.successMessage = null;
                this.errorMessage = null;
                // Send OTP logic here
                // Upon successful OTP sent, move to next step
                this.registrationStep = 2;
                this.otpWrongAttempts = 0;
                this.clearOtpLockTimer();
                this.otpForm = this.fb.group({
                  otp: ['', [Validators.required, Validators.pattern('^[0-9]{6}$'), Validators.minLength(6), Validators.maxLength(6)]],
                  transactionNumber: [sessionStorage.getItem('ipaddrss'), [Validators.required]],
                  aadhaarNumber: [response.data[0].mobile, [Validators.required]],
                  selectedIdType: ['ration'],
                });

                clearInterval(this.interval);
                this.resetTimer();
                this.startTimer();
              } else {
                const errorMsg ='Your data is not available in the Ration Card Database. You may still register using Aadhaar eKYC.';
               const translatedMsg = this.langService.getTranslationSync(errorMsg);
                this.toasterService.show(translatedMsg, {
                  class: 'danger',
                  title: 'Failure',
                });
                this.successMessage = null;
                this.errorMessage = null;
                this.registrationStep = 1;
              }
            },
            error: (error) => {
              this.isLoading = false;
              this.successMessage = null;
              this.errorMessage = null;
              this.toasterService.show(`Failed to send OTP. Please try again.`, {
                class: 'danger',
                title: 'Failure',
              });
            }
          });
        }
        // else if (this.aadhar.value.selectedIdType === 'mahaid') {
        //   this.mahaId = await this.getUserMahaID(this.aadhar.value.mahaId);
        //   if (this.mahaId !== null && this.mahaId !== undefined && this.mahaId.length > 0) {
        //     if (this.eKycProcess.key == '795e6dfe252d6116fe68b4fa8bda485c65cd3a2c')//redirect to sso portal
        //     {
        //       this.loginOpenID();
        //     }
        //     else {
        //       this.loginOpenID();
        //     }

        //   }
        //   else {
        //     this.toasterService.show(`Maha ID not found. Please check and try again.`, {
        //       class: 'danger',
        //       title: 'Failure',
        //     });
        //     this.successMessage = null;
        //     this.errorMessage = null;
        //   }
        // }
        //uncomment this when register flow work with ValautKey//
        //this.aadharvaluatkey = this.aadhar.value.aadharNumber;
        // if (this.aadharvaluatkey !== null && this.aadharvaluatkey !== undefined) {

        //   const userdata = this.reKyc != 'reKyc' ? await this.getUserMasterData(this.aadharvaluatkey) : null;
        //   if (userdata != null && userdata.length > 0) {
        //     this.usermasterdata = userdata[0];
        //     //this.successMessage = 'User Already Exists!';
        //     this.successMessage = null;
        //     //this.errorMessage = 'User Already Exists!';
        //     this.errorMessage = null;
        //     //comment by umed ali
        //     // this.toasterService.show(`User Already Exists!`, {
        //     //   class: 'danger',
        //     //   title: 'Failure',
        //     // });

        //     // this.loginOpenID();
        //   } else {
        //     let localUserData = JSON.parse(sessionStorage.getItem('userData'));
        //     if (localUserData == null || this.aadharvaluatkey === localUserData.aadharrefno) {
        //       this.isLoading = true;
        //       let aadharnumber = this.encryptionService.encrypt(this.aadhar.value.aadharNumber);
        //       let userType='Citizen';
        //       this.citizenService.sendAadharMobileOTP(aadharnumber,userType).subscribe({
        //         next: (response: AadharOtpResponse) => {
        //           this.isLoading = false;
        //           if (response.status == true) {
        //             this.toasterService.show(`OTP sent successfully!`, {
        //               class: 'success',
        //               title: 'Success',
        //             });
        //             this.successMessage = null;
        //             this.errorMessage = null;
        //             // Send OTP logic here
        //             // Upon successful OTP sent, move to next step
        //             this.registrationStep = 2;
        //             this.otpForm = this.fb.group({
        //               otp: ['', [Validators.required, Validators.pattern('^[0-9]{6}$'), Validators.minLength(6), Validators.maxLength(6)]],
        //               transactionNumber: [response.transactionNo, [Validators.required]],
        //               aadhaarNumber: [aadharnumber, [Validators.required]],
        //               selectedIdType: [''],
        //             });
        //             clearInterval(this.interval);
        //             this.resetTimer();
        //             this.startTimer();
        //           } else {
        //             this.toasterService.show(`Failed to send OTP. Please try again.`, {
        //               class: 'danger',
        //               title: 'Failure',
        //             });
        //             this.successMessage = null;
        //             this.errorMessage = null;
        //             this.registrationStep = 1;
        //           }
        //         },
        //         error: (error) => {
        //           this.isLoading = false;
        //           this.successMessage = null;
        //           this.errorMessage = null;
        //           this.toasterService.show(`Failed to send OTP. Please try again.`, {
        //             class: 'danger',
        //             title: 'Failure',
        //           });
        //         }
        //       });
        //     }
        //     else {
        //       this.toasterService.show(`The Aadhaar number entered does not belong to the logged-in user. Please enter your own Aadhaar.`, {
        //         class: 'danger',
        //         title: 'Failure',
        //       });
        //     }

        //   }
        // }
      } catch (error) {
       // this.loginOpenID();
        if (error.ok == false) {
          this.toasterService.show(`OTP request has failed due to an issue at UIDAI server side. Please re-try after 15 minutes.`, {
            class: 'danger',
            title: 'Failure',
          });
        }
      }

    }
    else {
      this.DS.registerFormmarkFormGroupTouched(this.aadhar)
    }
  }
  otpBoxes = Array(6).fill(0);
  otpValues: string[] = [];

  onOtpInput(event: any, index: number) {
    const value = event.target.value;

    if (!/^[0-9]$/.test(value)) {
      event.target.value = '';
      return;
    }

    this.otpValues[index] = value;

    // Move focus forward
    if (event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
    }

    this.updateOtpControl();
  }

  onBackspace(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    if (input.value) {
      input.value = '';
      this.otpValues[index] = '';
    }
    else if (index > 0) {
      const inputs = document.querySelectorAll('.otp-input') as NodeListOf<HTMLInputElement>;
      inputs[index - 1].focus();
      inputs[index - 1].value = '';
      this.otpValues[index - 1] = '';
    }

    event.preventDefault();
    this.updateOtpControl();
  }

  updateOtpControl() {
    const otp = this.otpValues.join('');
    this.otpForm.get('otp')?.setValue(otp);
  }

  showRationCardSuccessModal() {
    this.RationCard=this.Memberid;
    const modalElement = document.getElementById('rationCardSuccess');
const memberElement = document.getElementById('memberId');

if (memberElement) {
  memberElement.innerHTML = this.Memberid;
}

const rationRefNoElement = document.getElementById('rationRefNo');

if (rationRefNoElement) {
  rationRefNoElement.innerHTML = this.RationcardAadharrefkey;
}

    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }


  submitOTP() {
    //Submit OTP logic here
    //Upon successful OTP submission, move to next step
    //this.registrationStep = 3;
    if (this.otpForm.valid) {
          if (this.aadhar.value.selectedIdType === 'aadhar'){
          var data = {
          "aadhaarNumber": this.otpForm.value.aadhaarNumber,
          "transactionNumber": this.otpForm.value.transactionNumber,
          "otp": this.otpForm.value.otp
          }
          this.isLoading = true;
          this.citizenService.verifyAadharMobileOTP(data).subscribe({
          next: (response: any) => {
          this.isLoading = false;
          if (response.status == true) {
          this.sessionid = response.sessionid;
          //this.successMessage = response.message;
          //this.toasterService.show(response.message, {
          //  class: 'success',
          //  title: 'Success',
          //});
          this.minutesDisplay = '02';
          this.secondsDisplay = '00';
          this.totalSeconds = 120;
          clearInterval(this.interval);
          //this.router.navigate(['/citizen/newdetails']);

          if (this.reKyc != 'reKyc') {
          this.otpForm.reset();
          this.aadhar.reset();
          this.registerModal.hide();
          document.body.classList.remove('modal-open');
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
          document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());

          this.pendingOtpResponse = response;
          //this.openGovEmployeeModal();
             this.pendingOtpResponse = response;
          var state=this.encryptionService.decrypt(response.aadhardetails[0].state)

          if (state?.toLowerCase() !== 'maharashtra') {
            this.openGovEmployeeModal();
          }
          else{
                this.router.navigate(['/consent-to-access-registered'], { state: { detail: response.aadhardetails, sessionId: this.sessionid,isGovEmployee: false } });
 
          }
          //this.router.navigate(['/home/citizen-register'], { state: { detail: response.aadhardetails } });
          //               this.router.navigate(['/home/citizen-register'], {
          //   state: { detail: response.aadhardetails }
          // }).then(() => {
          //   this.loginService.triggerLogout();// 🔁 triggers reloadHeader() in HeaderComponent
          // });

          }
          else {
          let userData = JSON.parse(sessionStorage.getItem('userData'));
          var requestData = {
          adhrefNo: userData.aadharrefno,
          citizenuniqueid: userData.citizen_unique_id
          }
          this.otpForm.reset();
          this.aadhar.reset();
          this.registerModal.hide();
          document.body.classList.remove('modal-open');
          this.citizenService.updateAadharData(requestData).subscribe({
          next: (response) => {
            this.toasterService.show(`eKYC verification has been completed successfully!`, {
              class: 'success',
              title: 'Success',
            });
            this.router.navigate(['/citizen/profile'], { queryParams: { reload: new Date().getTime() } });

          },
          error: (error) => {
            console.error('Error storing record:', error);
          }
          });
          }
          } else {
          this.successMessage = null;
          this.errorMessage = null;
          // Show error message from API response with translation support
          const errorMsg = response.msg || 'Failed to verify OTP. Please try again.';
          const translatedMsg = this.langService.getTranslationSync(errorMsg);
          this.toasterService.show(translatedMsg, {
          class: 'danger',
          title: 'Failure',
          });
          // Wrong OTP entered: track attempts and lock out after 3 tries
          this.otpWrongAttempts++;
          if (this.otpWrongAttempts >= 3) {
            this.registerModal.hide();
            this.otpWrongAttempts = 0;
          } else {
            this.startOtpLockTimer();
          }
          // Clear OTP fields and close modal on error
          this.resetOTPFields();
          // this.registerModal.hide();
          }
          },
          error: (error) => {
          this.isLoading = false;
          this.successMessage = null;
          this.errorMessage = null;
          // Show error message from API response with translation support
          const errorMsg = error?.error?.msg || 'Failed to verify OTP. Please try again.';
          const translatedMsg = this.langService.getTranslationSync(errorMsg);
          this.toasterService.show(translatedMsg, {
          class: 'danger',
          title: 'Failure',
          });
          // Clear OTP fields and close modal on error
          this.resetOTPFields();
          //this.registerModal.hide();
          }
          });
          }
          else if (this.aadhar.value.selectedIdType === 'ration'){
            let data: SMSModel = {
              p_mode: 9,
              p_userid: '',
              p_mobileno:this.otpForm.value.aadhaarNumber,
              p_username: '',
              p_email: '',
              p_otp:  this.otpForm.value.otp,
              p_msg: '',
              p_url: '',
              p_ipaddress: this.IpAddess,
              p_messagetype: '',
              p_activitytype: '',
              p_templateid: 0,
              p_ticketid: '',
              p_time: '',
              GuidId: '',
            };
            //await this.homeService.verifyOTP(data).subscribe((res: any) => {
             this.homeService.verifyOTP(data).subscribe({
              next: (res: any) => {


                if (
                  res.status == 'true' &&
                  res.msg.toLowerCase() == 'valid otp'
                ) {
                    //Mobile OTP Verified Successfully
                  // this.toasterService.show(`Otp Validate Successfully. You completed your eKYC through Ration Card.`, {
                  //   class: 'success',
                  //   title: 'Succesfully',
                  // });

                             

                  this.RationcardAadharrefkey=this.Aadharrefkey;
                  this.isrationcard=true;
                  let dataration={
                    Memberid:this.Memberid,
                    MobileNo:this.otpForm.value.aadhaarNumber,
                    RationCard:this.RationCard,
                    Aadharrefkey:this.Aadharrefkey
                  }
                  this.citizenService.Rationcardvisitodetails(dataration).subscribe({
                    next: (response) => {
                           this.registerModal.hide();

                  this.showRationCardSuccessModal();  
                      //this.Memberid
                    }
                  })
                 // this.registerModal.show();
                  this.rationSwitchUsed=true;
                  //this.otpForm.reset();
                 // this.aadhar.reset();
                  //this.aadhar.get('selectedIdType')?.setValue('aadhar');
                  //this.selectedIdType = 'aadhar';
                  //this.registrationStep=1;
                  //this.aadhar.get('aadharNumber')?.reset();
                  //this.realAadhaarNumber = '';
                  this.showAadhaar = false;
                  this.isConsentUnlocked = false;
                  //this.aadhar.get('consent')?.reset();
                  // reset consent state
                  this.isScrolledToBottom = false;
                  //this.aadhar.get('consent')?.disable();
                  //this.aadhar.get('consent')?.reset();
                  console.log(this.Memberid);

                } else {

                  this.toasterService.show('Mobile ' + res.data[0].msg, {
                    class: 'danger',
                    title: 'Failure',
                  });
                  // Wrong OTP entered: track attempts and lock out after 3 tries
                  this.otpWrongAttempts++;
                  if (this.otpWrongAttempts >= 3) {
                    this.registerModal.hide();
                    this.otpWrongAttempts = 0;
                  } else {
                    this.startOtpLockTimer();
                  }
                  this.resetOTPFields();
                }
              },
              error: (error) => {
                //this.errorMessageMobileOTP = 'Failed to verify OTP. Please try again.';
                this.toasterService.show(
                  'Failed to verify Mobile OTP. Please try again.',
                  {
                    class: 'danger',
                    title: 'Failure',
                  },
                );
                this.resetOTPFields();
              },
            });
          }
    }
  }
showAadhaar = false;
realAadhaarNumber = '';

onAadhaarBeforeInput(event: InputEvent, input: HTMLInputElement) {
  event.preventDefault();

  if (event.inputType === 'deleteContentBackward') {
    this.realAadhaarNumber = this.realAadhaarNumber.slice(0, -1);
  }

  if (event.data && /^[0-9]$/.test(event.data)) {
    if (this.realAadhaarNumber.length < 16) {
      this.realAadhaarNumber += event.data;
    }
  }

  this.updateAadhaarInput(input);
}

toggleAadhaar(input: HTMLInputElement) {
  this.showAadhaar = !this.showAadhaar;
  this.updateAadhaarInput(input);
}

updateAadhaarInput(input: HTMLInputElement) {
  this.aadhar.get('aadharNumber')?.setValue(this.realAadhaarNumber, {
    emitEvent: false
  });

  input.value = this.showAadhaar
    ? this.realAadhaarNumber
    : this.maskAadhaar(this.realAadhaarNumber);
}

maskAadhaar(value: string): string {
  if (!value) return '';

  const digits = value.replace(/\D/g, '');

  let result = '';

  if (digits.length <= 8) {
    // mask everything till 8 digits
    result = 'X'.repeat(digits.length);
  } else {
    // first 8 masked, rest visible
    const masked = 'X'.repeat(8);
    const visible = digits.slice(8);
    result = masked + visible;
  }

  // format with dash every 4 chars
  return result
    .replace(/(.{4})/g, '$1-')
    .replace(/-$/, '');
}
  submitPassword() {
    // Submit Password logic here
    // Upon successful registration, move to success message step
    this.registrationStep = 4;
    setTimeout(() => {
      this.registerModal.hide();
    }, 2000);
  }
  getValidators(methodId: string): ValidatorFn[] {
    switch (methodId) {
      case 'aadhar_number':
        return [Validators.required, Validators.pattern('\\d{12}'), Validators.minLength(12), Validators.maxLength(12)];
      case 'email':
        return [Validators.required, Validators.email];
      case 'mobile':
        return [Validators.required, Validators.pattern('\\d{10}'), Validators.minLength(10), Validators.maxLength(10)];
      default:
        return [Validators.required];
    }
  }

  getAadharVaultKey(aadharNumber: string): Promise<any> {

    return new Promise((resolve, reject) => {
      this.citizenService.getAadharVaultKey(aadharNumber.toString()).subscribe(
        (response: any) => {
          resolve(response.responseKey);
        },
        (error: any) => {
          console.error('Error fetching Aadhar Vault Key:', error);
          reject(error);
        }
      );
    });
  }

  // getUserMasterData(aadharRefno: string): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.citizenService.getUserMasterData(aadharRefno.toString()).subscribe(
  //       (res: any) => resolve(res),
  //       (error: any) => reject(error)
  //     );
  //   });
  // }
  updateTimer(): void {
    if (this.totalSeconds > 0) {
      this.totalSeconds--;
      this.secondsDisplay = this.formatTime(this.totalSeconds % 60);
      this.minutesDisplay = this.formatTime(Math.floor(this.totalSeconds / 60));
    } else {
      this.isdisableResend = false;
      clearInterval(this.interval);
    }
  }

  formatTime(time: number): string {
    return time < 10 ? `0${time}` : `${time}`;
  }

  resetTimer(): void {
    this.totalSeconds = 120;
    this.minutesDisplay = '02';
    this.secondsDisplay = '00';
  }

  startTimer(): void {
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }

  resendOTP() {
    if (this.aadhar.valid) {
      this.isLoading = true;
      let aadharnumber = this.encryptionService.encrypt(this.aadhar.value.aadharNumber);
         let userType='Citizen';
      this.citizenService.sendAadharMobileOTP(aadharnumber,userType).subscribe({
        next: (response: AadharOtpResponse) => {
          this.isLoading = false;
          if (response.status == true) {
            this.isdisableResend = true;
            //this.successMessage = 'OTP Re-send successfully!';
            this.successMessage = null;
            this.toasterService.show('OTP Re-send successfully!', {
              class: 'success',
              title: 'Success',
            });
            this.registrationStep = 2;
            this.otpWrongAttempts = 0;
            this.clearOtpLockTimer();
            this.otpForm.reset();
            this.otpForm = this.fb.group({
              otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
              transactionNumber: [response.transactionNo, [Validators.required]],
              aadhaarNumber: [aadharnumber, [Validators.required]],
            });
            clearInterval(this.interval);
            this.resetTimer();
            this.startTimer();
          } else {
            //this.successMessage = 'Failed to send OTP. Please try again.';
            this.successMessage = null;
            this.toasterService.show(`Failed to send OTP. Please try again.`, {
              class: 'danger',
              title: 'Failure',
            });
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.errorMessage = null;
          this.toasterService.show(`Failed to send OTP. Please try again.`, {
            class: 'danger',
            title: 'Failure',
          });
        }
      });
    }
  }
  loginOpenID() {
    var data = {
      maha_id: '001',
      password: 'test',
      language: this.activeLanguage
    };
    this.loginService.loginOpenID(data).subscribe((res: any) => {
      window.location.href = res;
    });
  }
  // getUserMahaID(mahaID: string): Promise<any> {
  //   let requestData = {
  //     mode: 4,
  //     //user_id: formValues.username.trim(),
  //     user_id: "",
  //     data: JSON.stringify("{}"),
  //     //createdby: formValues.username.trim(),
  //     createdby: "",
  //     mahaid: this.aadhar.value.mahaId,
  //     citizenuniqueid: "",
  //   }
  //   return new Promise((resolve, reject) => {
  //     this.citizenService.citizenUserData(requestData).subscribe(
  //       (res: any) => resolve(res),
  //       (error: any) => reject(error)
  //     );
  //   });


  //   this.citizenService.citizenUserData(requestData).subscribe((res: any) => {
  //   })
  // }
  handleKeyboardEvent = (event: KeyboardEvent) => {

    if (event.shiftKey && event.key === 'v') {
      this.textToSpeechService.toggleSpeech()
      event.preventDefault(); // stop browser default

    }
  };
//   playAudio() {

//      this.langTranslation.language$.subscribe((language: any) => {
//       this.activeLanguage = language;
//         if(this.activeLanguage=='mr')
//     {
// new Audio('assets/ElevenLabs_2026-04-07T13_24_03_Shekhar.mp3').play();
//     }
//     else{
// new Audio('assets/ElevenLabs_2026-04-07T13_19_19_Kushal.mp3').play();
//     }
//     });

// }
  performEKycBiometric() {
    //this.loaderSpinShow();
    let aadhaarNumber: String = this.aadhar.value.aadharNumber;
    this.rdservice.getPidDataForBiometricEKYC().then(response => {
      let errorText = "errInfo=\"";
      if (response.includes(errorText)) {
        let index = response.indexOf(errorText);
        let index1 = response.indexOf("\"", index + errorText.length);
        let errorMsg = response.substring(index + errorText.length, index1);
        if (errorMsg.length > 0 && !errorMsg.includes('Success.')) {
          //this.loaderSpinHide();
          //this.showWarn(errorMsg);
          return;
        }
      }

      let obj = {
        aadhaarNumber: aadhaarNumber,
        deviceId: "",
        txnId: "",
        pidData: this.rdservice.prepareXmlForJson(response)
      };
      // this.farmerRegistryEkycService.requestEkycDataByBiometricV2(obj).subscribe(
      //   (response: any) => {
      //     if (response && response.data) {

      //       const decryptedData = this.esaEncryptionService.decryptText(response.data);
      //       response.data = decryptedData;

      //       if (response.data?.isSuccess === false ) {
      //         //this.showWarn(response.data.errorMsg);
      //       } else {
      //         this.isOldMobileVerified = true;
      //         this.newMobileNumber.setValue(null);
      //         this.newMobileNumber.enable({onlySelf: true});
      //       }
      //     }
      //     //this.loaderSpinHide();
      // }, (error) => {
      //   console.log(error);
      //   //this.loaderSpinHide();
      //   //this.showWarn(error);
      // })
    }).catch(error => {
      //this.loaderSpinHide();
      //this.showWarn(error);
    });
  }
  showRation = false;
  realRationcardmemberId = '';
  onRationBeforeInput(event: InputEvent, input: HTMLInputElement) {
    event.preventDefault();

    if (event.inputType === 'deleteContentBackward') {
      this.realRationcardmemberId = this.realRationcardmemberId.slice(0, -1);
    }

    if (event.data && /^[0-9]$/.test(event.data)) {
      if (this.realRationcardmemberId.length < 14) {
       // this.realAadhaarNumber += event.data;
        this.realRationcardmemberId+= event.data;
      }
    }

    this.updateRationInput(input);
  }
  updateRationInput(input: HTMLInputElement) {
    this.aadhar.get('rationCardMemberId')?.setValue(this.realRationcardmemberId, {
      emitEvent: false
    });

    input.value = this.showRation
      ? this.realRationcardmemberId
      : this.maskeRation(this.realRationcardmemberId);
  }
  maskeRation(value: string): string {
    if (!value) return '';

    const digits = value.replace(/\D/g, '');

    let result = '';

    if (digits.length <= 8) {
      // mask everything till 8 digits
      result = 'X'.repeat(digits.length);
    } else {
      // first 8 masked, rest visible
      const masked = 'X'.repeat(8);
      const visible = digits.slice(8);
      result = masked + visible;
    }

    // format with dash every 4 chars
    return result
      .replace(/(.{4})/g, '$1-')
      .replace(/-$/, '');
  }
  toggleRation(input: HTMLInputElement) {
    this.showRation = !this.showRation;
    this.updateRationInput(input);
  }

  goToEkycProcess() {
    const modalElement = document.getElementById('rationCardSuccess');

    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      modal?.hide();
    }
   this.Memberid = document.getElementById('memberId').textContent
   this.rationRefNo = document.getElementById('rationRefNo').textContent

      this.router.navigate(['/ekyc-process'],{ state: { detail:     this.Memberid , rationRefNo:     this.rationRefNo } });

  }

}
